import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { environment } from "../../environments/environment";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { IInvitation } from "../model/invitation.model";

@Injectable()
export class InvitationService{
    Invitations$!:Observable<IInvitation[]>;
    newInvitation$!:Observable<IInvitation>;
    createdInvitation!:IInvitation;

    private http = inject(HttpClient);
    authService = inject(AuthenticationService);
    
    getInvitations(): Observable<IInvitation[]> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.get<IInvitation[]>( environment.API_URL + '/api/UserInvitation/', options);
        } else {
            return of();
        }    
    }    

    sendInvitation(invitation: IInvitation): Observable<IInvitation> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<IInvitation>( environment.API_URL + '/api/UserInvitation/Create', invitation, options);
        } else {
            return of();
        }    
    }        

    cancelInvitation(id: string): Observable<IInvitation> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {            
            return this.http.post<IInvitation>( environment.API_URL + `/api/userinvitation/${id}`, options);
        } else {
            return of();
        }    
    }       
    deleteInvitation(id: string): Observable<IInvitation> {
        const token = this.authService.getUserToken();

        let options = { headers: new HttpHeaders( {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`}) };

        if (token !== undefined && token !== null && token !== '') {
            return this.http.post<IInvitation>( environment.API_URL + `/api/UserInvitation/delete/${id}`, options);
        } else {
            return of();
        }    
    }   
        
}